import { render, staticRenderFns } from "./Commissions.vue?vue&type=template&id=c38cf0ec&"
import script from "./Commissions.vue?vue&type=script&lang=js&"
export * from "./Commissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports